import { render, staticRenderFns } from "./PurchaseModalAnchor.vue?vue&type=template&id=ae70a21a&"
import script from "./PurchaseModalAnchor.vue?vue&type=script&lang=js&"
export * from "./PurchaseModalAnchor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports